import React, { useEffect, useState } from "react";
import { unidadDeLinea } from "../../../utils/unidades";
import { request } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import dayjs from "dayjs";
import Loader from "../../general/Loader";
import { money } from "../../../utils/helpers";

const ListaCarga = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const [despacho, setDespacho] = useState({});
    const [loading, setLoading] = useState(true);

    const getReporteData = async () => {
        setLoading(true);

        const url = `despachos/${id}`;
        const res = await request(url);
        setDespacho(res.data);
        setLoading(false);
    };

    useEffect(() => {
        getReporteData();
    }, []);

    // Espera a que loading pase a false, con los datos ya reflejados en el
    // DOM, antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (!loading) {
            window.print();
        }
    }, [loading]);

    // Una fila por producto y presentación: las cajas y las unidades sueltas
    // facturadas del mismo producto van en filas separadas, una debajo de la
    // otra (cajas primero).
    const productos = (() => {
        const grupos = new Map();

        (despacho.facturas || []).forEach((factura) =>
            factura.productos.forEach((prod) => {
                const factor = Number(prod.factor) || 1;
                const esEmpaque = factor > 1;
                const clave = `${prod.producto.id}|${
                    esEmpaque ? `${String(prod.unidad).toUpperCase()}|${factor}` : "base"
                }`;

                const existente = grupos.get(clave);
                if (existente) {
                    existente.cantidad += Number(prod.cantidad) || 0;
                    existente.cantidad_base +=
                        Number(prod.cantidad_base ?? prod.cantidad) || 0;
                } else {
                    grupos.set(clave, {
                        ...prod,
                        factor,
                        esEmpaque,
                        cantidad: Number(prod.cantidad) || 0,
                        cantidad_base:
                            Number(prod.cantidad_base ?? prod.cantidad) || 0,
                    });
                }
            })
        );

        const orden = [];
        grupos.forEach((item) => {
            if (!orden.includes(item.producto.id)) orden.push(item.producto.id);
        });

        return [...grupos.entries()]
            .map(([clave, item]) => ({ clave, ...item }))
            .sort(
                (x, y) =>
                    orden.indexOf(x.producto.id) - orden.indexOf(y.producto.id) ||
                    Number(y.esEmpaque) - Number(x.esEmpaque) ||
                    y.factor - x.factor
            );
    })();

    // Existencia en la presentación de la fila: el stock viene en unidad base.
    const existenciaDeFila = (item) => {
        const total = Number(item.producto.cantidad) || 0;
        if (!total) return "";

        if (item.esEmpaque) {
            return `${Math.floor(total / item.factor)} ${unidadDeLinea(item)}`;
        }

        return `${total} ${item.producto.unidad}`;
    };

    return (<>
		<style>{`@page {size: A4 landscape}`}</style>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
                Reporte Lista de Carga - Despacho de Facturas
            </h2>
            <div className="col-md-12 text-center">
                {sucursal.nombre} •{" "}
                {dayjs().format("DD/MM/YYYY")}
            </div>
        </div>

        {loading && <Loader/> }

        {!loading && <>
            <div className="row mt-3">
                <div className="col-12 d-md-none text-right p-b-10">
                    <strong>NO.</strong> {despacho.numero_despacho}
                </div>
                <div className="col-12 col-md-6 text-right p-b-10">
					<div className="float-left" style={{fontSize: 'large'}}>
						TOTAL PRODUCTOS: {productos.length}
					</div>
				</div>
                <div className="d-none col-6 d-md-block text-right p-b-10">
                    <strong>NO.</strong> {despacho.numero_despacho}
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <table className="table m-b-40" style={{fontSize: 'larger'}}>
                        <thead>
                            <tr className="text-uppercase">
                                <th>Ref./Cód.</th>
                                <th>Nombre del Producto</th>
                                <th>Almacén</th>
                                <th>Existencia</th>
                                <th>Ubicación</th>
                                <th className="text-right">Cant. a Despachar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productos.map((item) => {
                                return (
                                    <tr key={item.clave}>
                                        <td>
                                            {item.producto.referencia}
                                        </td>
                                        <td className="text-capitalize">
                                            {item.producto.nombre}
                                        </td>
                                        <td>
                                            {item.producto.almacen?.nombre}
                                        </td>
                                        <td>
                                            {existenciaDeFila(item)}
                                        </td>
                                        <td>
                                            {item.producto.ubicacion?.nombre}
                                        </td>
                                        <td className="text-right">
                                            {item.cantidad}{" "}
                                            {unidadDeLinea(item)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                </div>
            </div>
        </>}
    </>);
}

export default ListaCarga;